interface HighlightItem {
  emoji: string
  label: string
  motivation: string
}

interface Props {
  areaName: string
  weatherNarrative: string
  highlights: HighlightItem[]
}

export function TodaySlide({ areaName, weatherNarrative, highlights }: Props) {
  return (
    <div className="tv-today">
      <h2 className="tv-today__title">Today in {areaName}</h2>
      <p className="tv-today__narrative">{weatherNarrative}</p>
      {highlights.length > 0 && (
        <div className="tv-today__highlights">
          <span className="tv-today__highlights-label">Best today</span>
          <ul className="tv-today__list">
            {highlights.map((h, i) => (
              <li key={i} className="tv-today__highlight">
                <span className="tv-today__highlight-emoji">{h.emoji}</span>
                <span className="tv-today__highlight-text">
                  {h.label} &mdash; {h.motivation}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
